const urlScheme = /^([a-z][a-z0-9+.-]*):/i;

export function safeMarkdownHref(href: string | undefined): string | undefined {
  const trimmed = href?.trim();

  if (!trimmed) return undefined;

  const scheme = urlScheme.exec(trimmed)?.[1]?.toLowerCase();

  if (scheme && !["http", "https", "mailto"].includes(scheme)) return undefined;

  return trimmed;
}

export function safePostImageSrc(src: string | undefined): string | undefined {
  const trimmed = src?.trim();

  if (
    !trimmed ||
    !/^https:\/\/softmax-public\.s3\.amazonaws\.com(?::443)?\//i.test(trimmed)
  ) {
    return undefined;
  }

  const url = new URL(trimmed);

  // Check the normalized path so dot segments cannot fetch other bucket objects.
  if (
    url.origin !== "https://softmax-public.s3.amazonaws.com" ||
    !url.pathname.startsWith("/post-media/")
  ) {
    return undefined;
  }

  return url.href;
}

function isWikiRelative(href: string): boolean {
  return (
    !href.startsWith("/") && !href.startsWith("#") && !urlScheme.test(href)
  );
}

export function resolveMarkdownLink({
  href,
  wikiPageHref,
}: Readonly<{
  href: string;
  wikiPageHref:
    | ((target: Readonly<{ relativeHref: string }>) => string)
    | undefined;
}>): Readonly<{
  resolvedHref: string;
  internal: boolean;
  inPage: boolean;
  wikiRelative: boolean;
}> {
  const wikiRelative = wikiPageHref !== undefined && isWikiRelative(href);
  const resolvedHref = wikiRelative
    ? wikiPageHref({ relativeHref: href })
    : href;
  return {
    resolvedHref,
    internal: resolvedHref.startsWith("/") && !resolvedHref.startsWith("//"),
    inPage: resolvedHref.startsWith("#"),
    wikiRelative,
  };
}
